export const tabsNames = {
	basicInfo: 'basicInfo',
	details: 'details',
	dependencies: 'dependencies',
};

export const fieldsToTestBasicInfo = [
	'project',
	'title',
	'description',
];

export const fieldsToTestDetails = [
	'status',
	'priority',
	'milestone',
	'startDate',
	'endDate',
	'assignees',
];

export const taskFormFields = {
	project: 'project',
	title: 'title',
	description: 'description',
	startDate: 'startDate',
	endDate: 'endDate',
	assignees: 'assignees',
	status: 'status',
	milestone: 'milestone',
	priority: 'priority',
};
